(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6268],{

/***/ 95948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(64059);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41197);
/* harmony import */ var _elements_LazyImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20027);
/* harmony import */ var _helpers_getS3Url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27895);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34495);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79697);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);













var formatDate = function(date) {
    if (!date) return "";
    var d = moment__WEBPACK_IMPORTED_MODULE_7___default()(date).utc();
    return d.format("dddd, MMMM D, YYYY");
};
var BlogCard = function(param) {
    var title = param.title, short_description = param.short_description, hero_image = param.hero_image, categories = param.categories, image = param.image, published_date = param.published_date, category = param.category, slug = param.slug, cloudflare_hero_image = param.cloudflare_hero_image, cloudflare_picture = param.cloudflare_picture, date = param.date, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, buttonLabel = param.buttonLabel;
    var isSimilar = variant.includes("similar");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), formattedDate = ref[0], setFormattedDate = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var formatDateString = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var formatted;
                return _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return formatDate(published_date || date);
                        case 2:
                            formatted = _ctx.sent;
                            setFormattedDate(formatted);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function formatDateString() {
                return _ref.apply(this, arguments);
            };
        }();
        formatDateString();
    }, [
        published_date,
        date
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("article", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_9__/* .withModifiers */ .i)("card", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(variant), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default())),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                href: "/stories/".concat(slug),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card__image),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_elements_LazyImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sizes: "(min-width: 1250px) 590px, (max-width: 1250px) 100vw, 50vw",
                        layout: "fill",
                        objectFit: "cover",
                        objectPosition: "center",
                        src: (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_4__/* .getS3Url */ .v)(cloudflare_picture || cloudflare_hero_image || hero_image || image, "960")
                    })
                })
            }),
            isSimilar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card__details),
                children: [
                    (category || !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(categories)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card__category),
                        children: category || categories[0].title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card__date),
                        children: formattedDate
                    })
                ]
            }),
            !isSimilar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card__date),
                children: formattedDate
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card__title),
                children: title
            }),
            !isSimilar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: short_description
                }
            }),
            !isSimilar && categories && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().card__tag),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("em", {
                    children: categories
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
                name: buttonLabel,
                href: "/stories/".concat(slug),
                variant: [
                    "label",
                    isSimilar && "color-accent",
                    isSimilar && "primary"
                ],
                children: buttonLabel
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 51036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ custom_Message; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-message.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMessage = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 32,
  height: 37,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M31.125 36.5H.875a.497.497 0 0 1-.494-.497L.385 15.72a.494.494 0 1 1 .988 0L1.37 35.508H30.63l-.004-19.787a.494.494 0 1 1 .988 0l.004 20.281a.493.493 0 0 1-.493.497Z",
  fill: "#999"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M16.004 30.144h-.012a.484.484 0 0 1-.334-.131L.546 16.085a.496.496 0 0 1 .67-.728L16 28.981l14.783-13.624a.496.496 0 0 1 .7.029c.185.2.17.512-.029.699L16.341 30.01a.492.492 0 0 1-.337.133Z",
  fill: "#999"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M31.124 36.498a.486.486 0 0 1-.291-.096l-12.245-9.005a.498.498 0 0 1-.106-.692.498.498 0 0 1 .692-.106l12.245 9.005c.22.163.266.47.106.692a.502.502 0 0 1-.4.203ZM.875 36.5a.494.494 0 0 1-.292-.895L12.829 26.6a.494.494 0 1 1 .586.799L1.17 36.404a.498.498 0 0 1-.295.096ZM25.712 21.198a.494.494 0 0 1-.494-.494V5.562H6.781v15.14a.494.494 0 1 1-.988 0V5.069c0-.273.22-.494.494-.494h19.425c.273 0 .494.221.494.494v15.635c0 .273-.22.495-.494.495Z",
  fill: "#999"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M11.885 5.562a.494.494 0 0 1-.348-.845L15.65.643a.494.494 0 1 1 .697.703l-4.114 4.073a.498.498 0 0 1-.348.143Z",
  fill: "#999"
})), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
  d: "M20.106 5.563a.492.492 0 0 1-.348-.143l-4.106-4.075a.495.495 0 0 1 .696-.702l4.106 4.075a.495.495 0 0 1-.348.845ZM.881 16.218a.494.494 0 0 1-.343-.848l5.408-5.265a.494.494 0 1 1 .689.709l-5.409 5.262a.496.496 0 0 1-.345.142ZM31.12 16.216a.49.49 0 0 1-.345-.141l-5.407-5.265a.496.496 0 0 1 .69-.71l5.406 5.266a.495.495 0 0 1-.343.85Z",
  fill: "#999"
})), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
  d: "M16 21.395a6.066 6.066 0 0 1-4.324-1.793 6.068 6.068 0 0 1-1.793-4.324c0-1.634.635-3.17 1.793-4.325A6.06 6.06 0 0 1 16 9.16c1.634 0 3.17.636 4.325 1.793a6.064 6.064 0 0 1 1.793 4.325c0 1.633-.635 3.169-1.793 4.324A6.08 6.08 0 0 1 16 21.395Zm0-11.247a5.136 5.136 0 0 0-5.129 5.13 5.136 5.136 0 0 0 5.13 5.13 5.136 5.136 0 0 0 5.129-5.13c0-2.83-2.302-5.13-5.13-5.13Z",
  fill: "#B18D3B"
})), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
  d: "M14.849 17.761a.478.478 0 0 1-.348-.146l-1.685-1.68a.496.496 0 0 1 .7-.7l1.334 1.336 3.633-3.634a.495.495 0 0 1 .7.7L15.2 17.618a.494.494 0 0 1-.351.143Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_message = (SvgIconMessage);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
// EXTERNAL MODULE: ./components/custom/Message/styles.module.scss
var styles_module = __webpack_require__(14234);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/custom/Message/index.js






var Message = function(param) {
    var title = param.title, subtitle = param.subtitle, button = param.button, _type = param.type, type = _type === void 0 ? "success" : _type;
    var handleCloseModal = (0,modalProvider/* useModalContext */.vR)().handleCloseModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,withModifiers/* withModifiers */.i)("message", [
            type
        ], (styles_module_default())),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_message, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (styles_module_default()).message__title,
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (styles_module_default()).message__subtitle,
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                onClick: function() {
                    return handleCloseModal();
                },
                href: button.href && button.href,
                arrow: button === null || button === void 0 ? void 0 : button.arrow,
                children: button.label
            })
        ]
    });
};
/* harmony default export */ var custom_Message = (Message);


/***/ }),

/***/ 20027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var LazyImage = function(_param) {
    var src = _param.src, index = _param.index, width = _param.width, height = _param.height, alt = _param.alt, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "index",
        "width",
        "height",
        "alt"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), blur = ref[0], setBlur = ref[1];
    var getSmallImageSrc = function(src) {
        // Ensure src is a string before calling replace
        if (typeof src === "string") {
            return src.replace(/\b(1980|3840|640|960|360)\b/g, "64");
        }
        return null;
    };
    var isLayout = props.layout === "fill";
    // Filter out srcSet and sizes from props as Next.js Image doesn't support them directly
    // eslint-disable-next-line no-unused-vars
    var srcSet = props.srcSet, sizes = props.sizes, imageProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "srcSet",
        "sizes"
    ]);
    // Only render if src is a valid string
    if (src && typeof src === "string") {
        var blurDataURL = getSmallImageSrc(src);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            width: !isLayout && (width || 590),
            height: !isLayout && (height || 393),
            src: src,
            blurDataURL: blurDataURL,
            placeholder: blurDataURL ? "blur" : "empty",
            className: blur ? "img-blur" : "unblur",
            onLoadingComplete: function() {
                return setBlur(false);
            },
            alt: alt || "Property presentation image ".concat(index)
        }, imageProps));
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyImage);


/***/ }),

/***/ 24447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6644);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34495);
/* harmony import */ var _LazyImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20027);
/* eslint-disable react/prop-types */ 









var CloudflareVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69562)
            ];
        }
    }
});
var Section = function(_param) {
    var children = _param.children, className = _param.className, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, bg = _param.bg, _video = _param.video, video = _video === void 0 ? false : _video, cloudflare = _param.cloudflare, _separator = _param.separator, separator = _separator === void 0 ? false : _separator, sectionRef = _param.sectionRef, _grayscale = _param.grayscale, grayscale = _grayscale === void 0 ? false : _grayscale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "variant",
        "bg",
        "video",
        "cloudflare",
        "separator",
        "sectionRef",
        "grayscale"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: sectionRef,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(variant).concat([
            separator && "has-separator",
            bg && "with-bg"
        ]), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())), className)
    }, props), {
        children: [
            bg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: bg,
                priority: true,
                objectPosition: "center",
                objectFit: "cover",
                sizes: "(max-width: 360px) 960px, (max-width: 640px) 960px, (max-width: 1400px) 1400px, 1980px",
                alt: "section background image",
                layout: "fill"
            }),
            (cloudflare || video) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section__video", [
                    grayscale && "grayscale"
                ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloudflareVideo, {
                        name: "Section presentation video",
                        autoplay: true,
                        loop: true,
                        muted: true,
                        src: cloudflare || video
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__overlay)
                    })
                ]
            }),
            separator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__separator)
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Section);


/***/ }),

/***/ 47944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64636);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41197);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19403);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92375);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _providers_modalProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51472);
/* harmony import */ var _custom_Message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51036);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34495);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);











var Subscribe = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? [] : _variant, translations = param.translations;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), mails = ref[0], setMails = ref[1];
    var ref1 = (0,_providers_modalProvider__WEBPACK_IMPORTED_MODULE_5__/* .useModalContext */ .vR)(), handleShowModal = ref1.handleShowModal, setContent = ref1.setContent, setVariant = ref1.setVariant;
    var isLarge = variant.includes("large");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var formInitialValues = {
        email: ""
    };
    var validationSchema = function(values) {
        var errors = {};
        if (values.email !== "") {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = translations.error.emailError[router.locale];
            }
        }
        return errors;
    };
    var handleSubmit = function(values, param) {
        var setSubmitting = param.setSubmitting;
        setSubmitting(true);
        _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("active/pipe", {
            email: values.email
        }).then(function(res) {
            var ref, ref1;
            if ((ref = res.data[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.error) === null || ref1 === void 0 ? void 0 : ref1.includes(translations.error.emailExists[router.locale])) {
                setMails((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(mails).concat([
                    values.email
                ]));
            } else {
                setVariant([
                    "contained",
                    "xs"
                ]);
                setContent(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Message__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    title: translations.success.title[router.locale],
                    subtitle: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            translations.success.subtitle[router.locale],
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                rel: "nofollow",
                                href: "mailto:reservations@sxmsir.com",
                                children: "reservations@sxmsir.com"
                            })
                        ]
                    }),
                    button: {
                        label: translations.success.button[router.locale],
                        href: "/vacation-rentals"
                    }
                }));
                handleShowModal();
            }
        }).catch(function(err) {
            return console.error(err);
        });
        setSubmitting(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
        initialValues: formInitialValues,
        enableReinitialize: true,
        validate: validationSchema,
        onSubmit: handleSubmit,
        children: function(param) {
            var values = param.values, errors = param.errors, touched = param.touched, handleChange = param.handleChange, handleBlur = param.handleBlur;
            var disabled = values.email === formInitialValues.email || mails.includes(values.email) || errors.email && touched.email;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_9__/* .withModifiers */ .i)("form", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(variant), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default())),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                        type: "email",
                        name: "email",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        value: values.email,
                        placeholder: isLarge ? translations.fields.email[router.locale] : translations.fields.subscribe[router.locale],
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().form__field)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().form__error),
                        children: [
                            errors.email && touched.email && errors.email,
                            mails.includes(values.email) && translations.error.subscribed[router.locale]
                        ]
                    }),
                    !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        variant: [
                            isLarge ? "primary-blue" : "secondary"
                        ],
                        name: "subscribe",
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().form__button),
                        children: isLarge ? translations.fields.submit[router.locale] : ""
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Subscribe);


/***/ }),

/***/ 27895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getS3Url; }
/* harmony export */ });
/* harmony import */ var lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27771);
/* harmony import */ var lodash_es_isString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36378);
/* eslint-disable no-undef */ 

// URL cache to avoid redundant calculations
var urlCache = {};
// Detect mobile once and reuse
var isMobile = false;
var isMobileLandscape = false;
// Set up mobile detection only on client
if (true) {
    // Set this once at module level for initial render
    isMobile = window.innerWidth < 360;
    isMobileLandscape = window.innerWidth >= 360 && window.innerWidth < 640;
    // Update on resize with debouncing
    var resizeTimeout;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            var width = window.innerWidth;
            isMobile = width < 360;
            isMobileLandscape = width >= 360 && width < 640;
        }, 200);
    });
}
function getS3Url(url) {
    var variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "public", video = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // Return early if no URL
    if (!url || !(0,lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(url) && !(0,lodash_es_isString__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(url)) {
        return;
    }
    // For server-side rendering, use largest image
    var isServerSide = "object" === "undefined";
    // Use server defaults or client detection
    var effectiveIsMobile = isServerSide ? false : isMobile;
    var effectiveIsMobileLandscape = isServerSide ? false : isMobileLandscape;
    // Generate a cache key
    var cacheKey = "".concat(url, "-").concat(variant, "-").concat(video, "-").concat(effectiveIsMobile, "-").concat(effectiveIsMobileLandscape);
    // Return cached URL if available
    if (urlCache[cacheKey]) {
        return urlCache[cacheKey];
    }
    var result;
    // Determine which type of URL this is
    if (url.includes("images/") || url.includes("videos/")) {
        result = "https://assets.sxmsir.com/" + url.replaceAll(" ", "%20");
    } else if (video) {
        result = "https://customer-".concat("mwbbzmyggbfuda1b", ".cloudflarestream.com/").concat(url, "/manifest/video.m3u8");
    } else {
        // Determine the cloudflare variant to use
        var cloudflareVariant;
        // Server-side: Prioritize provided variant if it exists, otherwise use largest
        if (isServerSide) {
            cloudflareVariant = variant && variant !== "public" && variant !== "" ? variant // Use provided variant if it exists and is not 'public' or empty
             : "1980" // Otherwise use largest variant for server-side
            ;
        } else {
            // Client-side: Use existing responsive logic
            cloudflareVariant = effectiveIsMobile ? 360 : effectiveIsMobileLandscape ? 640 : variant === "public" || variant === "" || !variant ? 960 : variant;
        }
        result = "https://imagedelivery.net/".concat("356b0XxwgMp5GfAe77K8NQ", "/").concat(url, "/").concat(cloudflareVariant);
    }
    // Cache the result
    urlCache[cacheKey] = result;
    return result;
}


/***/ }),

/***/ 95109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ blog_Subscribe; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-newslsetter.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconNewslsetter = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 56,
  height: 48,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M55.261 48.001H1.24a.495.495 0 0 1-.489-.5c0-.277.219-.501.489-.501H55.26c.27 0 .489.224.489.5 0 .277-.219.501-.489.501ZM5.54 15.117l6.292-3.695v9.549L5.54 15.117Z",
  fill: "#B18D3B"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M11.837 21.473a.478.478 0 0 1-.329-.13l-6.293-5.854a.508.508 0 0 1 .084-.806l6.293-3.695a.476.476 0 0 1 .489.003c.15.088.244.255.244.433v9.548a.505.505 0 0 1-.29.46.544.544 0 0 1-.199.041ZM6.368 15.21l4.977 4.63.003-7.553-4.98 2.923ZM51.106 15.117l-6.294-3.695v9.549l6.294-5.854Z",
  fill: "#B18D3B"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M44.81 21.471a.485.485 0 0 1-.2-.042.505.505 0 0 1-.29-.458v-9.55c0-.18.094-.344.245-.432a.488.488 0 0 1 .489-.003l6.293 3.695c.135.08.226.222.242.38a.501.501 0 0 1-.158.426l-6.293 5.853a.49.49 0 0 1-.329.13v.001Zm.488-9.186v7.553l4.977-4.63-4.977-2.923ZM5.536 48.001a.46.46 0 0 1-.201-.044.502.502 0 0 1-.288-.456V15.118c0-.277.219-.5.489-.5s.488.223.488.5v31.264l16.76-15.29a.478.478 0 0 1 .69.041.51.51 0 0 1-.041.707L5.859 47.874a.463.463 0 0 1-.323.128Z",
  fill: "#B18D3B"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M44.818 21.434a.495.495 0 0 1-.488-.5V8.626L37.013 1H12.415v19.932c0 .276-.219.5-.489.5a.495.495 0 0 1-.489-.5V.5c0-.277.22-.501.49-.501h25.29c.13 0 .257.055.348.149l7.6 7.921a.51.51 0 0 1 .14.352v12.514a.49.49 0 0 1-.487.498Z",
  fill: "#B18D3B"
})), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
  d: "M33.626 31.966h-10.52a.48.48 0 0 1-.328-.13L5.208 15.49a.508.508 0 0 1-.034-.707.482.482 0 0 1 .69-.034l17.434 16.219 10.14-.003 17.434-16.218a.482.482 0 0 1 .69.033.508.508 0 0 1-.033.707l-17.574 16.35a.48.48 0 0 1-.329.13Z",
  fill: "#B18D3B"
})), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
  d: "M51.196 47.997a.486.486 0 0 1-.326-.127L33.296 31.836a.51.51 0 0 1-.04-.707.482.482 0 0 1 .69-.042L50.707 46.38V15.406l-6.046-3.55a.507.507 0 0 1-.18-.682.481.481 0 0 1 .666-.185l6.29 3.694a.503.503 0 0 1 .248.436v32.383a.503.503 0 0 1-.288.456.551.551 0 0 1-.201.04ZM44.815 8.92h-7.6a.495.495 0 0 1-.488-.5V.5c0-.276.219-.5.488-.5.27 0 .49.224.49.5v7.422h7.11c.27 0 .488.224.488.5a.494.494 0 0 1-.488.498ZM26.22 21.828h-9.66a.495.495 0 0 1-.49-.5V12.36c0-.276.22-.5.49-.5h9.66c.27 0 .49.224.49.5v8.968c0 .276-.22.5-.49.5Zm-9.172-1.001h8.684V12.86h-8.684v7.966ZM34.337 20.538h-5.012a.495.495 0 0 1-.49-.501v-1.974c0-.276.22-.5.49-.5h5.012c.27 0 .49.224.49.5v1.977a.494.494 0 0 1-.49.498Zm-4.524-1.002h4.036v-.975h-4.035v.975ZM41.09 14.15H29.247a.495.495 0 0 1-.49-.5c0-.277.22-.502.49-.502h11.84c.27 0 .489.225.489.501a.491.491 0 0 1-.486.5ZM26.87 7.408H16.56a.495.495 0 0 1-.49-.501c0-.277.22-.5.49-.5h10.31c.27 0 .488.223.488.5 0 .276-.219.5-.489.5ZM37.042 16.353h-7.795a.495.495 0 0 1-.49-.5c0-.277.22-.501.49-.501h7.795c.27 0 .489.224.489.5 0 .277-.22.5-.49.5Z",
  fill: "#B18D3B"
})), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
  d: "M18.552 16.186a.49.49 0 0 1-.346-.146.51.51 0 0 1 0-.71l1.217-1.246a.482.482 0 0 1 .693 0 .51.51 0 0 1 0 .71l-1.218 1.246a.49.49 0 0 1-.346.146ZM18.552 18.368a.49.49 0 0 1-.346-.146.51.51 0 0 1 0-.709l3.368-3.452a.482.482 0 0 1 .692 0 .51.51 0 0 1 0 .709l-3.368 3.452a.49.49 0 0 1-.346.146ZM38.753 24.626H18.895a.495.495 0 0 1-.489-.5c0-.277.22-.501.489-.501H38.75c.27 0 .489.224.489.5a.491.491 0 0 1-.486.501ZM28.914 43.624c-.575 0-1.09-.08-1.538-.24a3.024 3.024 0 0 1-1.14-.701 3.024 3.024 0 0 1-.71-1.13 4.377 4.377 0 0 1-.245-1.514c0-.558.082-1.067.245-1.52a3.29 3.29 0 0 1 .715-1.174 3.16 3.16 0 0 1 1.153-.753c.453-.175.973-.264 1.553-.264.537 0 1.018.081 1.444.24.422.162.781.391 1.08.686.294.297.518.649.674 1.058.155.407.231.858.229 1.354.002.341-.028.652-.087.938a2.39 2.39 0 0 1-.28.746 1.464 1.464 0 0 1-.501.503 1.613 1.613 0 0 1-.749.209c-.209.016-.379 0-.509-.047a.59.59 0 0 1-.295-.216.76.76 0 0 1-.133-.334h-.033a.676.676 0 0 1-.254.3c-.128.088-.28.159-.464.208-.178.05-.371.068-.575.055a1.612 1.612 0 0 1-.606-.154 1.51 1.51 0 0 1-.507-.386 1.825 1.825 0 0 1-.346-.623 2.677 2.677 0 0 1-.127-.86c.003-.321.046-.603.135-.84a1.748 1.748 0 0 1 .835-.986 1.804 1.804 0 0 1 1.12-.177c.183.031.336.08.464.154.124.07.203.146.234.227h.038v-.31h.848v2.709a.5.5 0 0 0 .084.297.26.26 0 0 0 .219.104.38.38 0 0 0 .313-.17c.084-.111.147-.286.19-.518a5.03 5.03 0 0 0 .064-.892c0-.347-.046-.654-.135-.918a2.025 2.025 0 0 0-.374-.675 2.05 2.05 0 0 0-.557-.454c-.212-.117-.44-.2-.688-.255a3.652 3.652 0 0 0-.758-.081c-.451 0-.843.07-1.18.208-.335.141-.615.337-.84.587a2.45 2.45 0 0 0-.5.884 3.559 3.559 0 0 0-.171 1.103c.002.438.06.827.18 1.163.12.339.293.62.525.85.232.23.517.404.855.521.339.118.728.178 1.171.178.206 0 .413-.016.609-.047.198-.031.377-.068.54-.112.16-.045.29-.086.386-.125l.268.803a2.178 2.178 0 0 1-.464.187c-.193.06-.412.105-.656.141a4.14 4.14 0 0 1-.749.063Zm-.125-2.509c.222 0 .395-.044.527-.13a.73.73 0 0 0 .283-.386c.058-.172.084-.383.079-.633a1.819 1.819 0 0 0-.084-.566.652.652 0 0 0-.275-.352c-.13-.081-.308-.12-.537-.12a.96.96 0 0 0-.512.13.83.83 0 0 0-.318.365 1.275 1.275 0 0 0-.112.55c.002.196.033.381.091.558a.895.895 0 0 0 .296.425c.14.105.326.16.562.16Z",
  fill: "#B18D3B"
})));

/* harmony default export */ var icon_newslsetter = (SvgIconNewslsetter);
// EXTERNAL MODULE: ./components/general/Footer/components/Form/index.js
var Form = __webpack_require__(47944);
// EXTERNAL MODULE: ./components/pages/blog/Subscribe/styles.module.scss
var styles_module = __webpack_require__(14607);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/pages/blog/Subscribe/index.js







var Subscribe = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? [
        "white"
    ] : _variant, title = param.title, description = param.description, translations = param.translations;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        separator: variant.includes("separator"),
        variant: [
            "center"
        ].concat((0,_to_consumable_array/* default */.Z)(variant)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
            variant: [
                "-xs5"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_newslsetter, {}),
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                    translations: translations,
                    variant: [
                        "large",
                        "mobile-full"
                    ]
                }),
                description && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (styles_module_default()).label,
                    children: description
                })
            ]
        })
    });
};
/* harmony default export */ var blog_Subscribe = (Subscribe);


/***/ }),

/***/ 64059:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card__image":"styles_card__image__UUi8m","card__category":"styles_card__category__2u_2r","card__details":"styles_card__details__VQLuc","card__date":"styles_card__date__fLbWc","card__title":"styles_card__title__dcaVT","card__tag":"styles_card__tag__Rb4HX","card--similar":"styles_card--similar__FZy19"};

/***/ }),

/***/ 14234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__IQwiF","message__title":"styles_message__title__GlV0y","message__subtitle":"styles_message__subtitle__BZWor","message--error":"styles_message--error__hmqU0"};

/***/ }),

/***/ 6644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__yHGzn","section__image":"styles_section__image__3wu_0","section__separator":"styles_section__separator__jTwxZ","section__overlay":"styles_section__overlay__S4fzZ","section__video":"styles_section__video__aGMVE","section__video--grayscale":"styles_section__video--grayscale__cSkkv","section--separator-large":"styles_section--separator-large__e2xv7","section--has-separator":"styles_section--has-separator__9vXz9","section--separator-top":"styles_section--separator-top__EcwNQ","section--gray":"styles_section--gray__GL0Sw","section--white":"styles_section--white__NJa_K","section--contained":"styles_section--contained__Laf5M","section--center":"styles_section--center__LmG2q","section--primary":"styles_section--primary__GuN0k","section--darker":"styles_section--darker__uJmer","section--bg-body":"styles_section--bg-body__g_dZD","section--o-hidden":"styles_section--o-hidden__xJTM8","section--with-bg":"styles_section--with-bg__fgmbo","section--pt0":"styles_section--pt0__IoFne","section--full-height":"styles_section--full-height__xFIuY","section--bottom":"styles_section--bottom__hRh3f","section--p0":"styles_section--p0__CiUN0","section--pb0":"styles_section--pb0__OvCBe","section--p-xs":"styles_section--p-xs__AOSqe","section--p-xl":"styles_section--p-xl__9nhJz","section--z-7":"styles_section--z-7__RDdr0"};

/***/ }),

/***/ 19403:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__ya5V9","form__field":"styles_form__field__oUYqR","form__error":"styles_form__error__JtJGS","form__button":"styles_form__button__RJpQ8","form--large":"styles_form--large__ZDwXG","form--mobile-full":"styles_form--mobile-full__wI5pf"};

/***/ }),

/***/ 14607:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__Gpigg"};

/***/ }),

/***/ 36378:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseGetTag_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93589);
/* harmony import */ var _isArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27771);
/* harmony import */ var _isObjectLike_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18533);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!(0,_isArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value) && (0,_isObjectLike_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value) && (0,_baseGetTag_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["Z"] = (isString);


/***/ })

}]);